const baseURL = 'https://curaduria1bucaramanga.com/public_docs/OTHERS/osha/2. Politicas SG-SST/';

export const _policies = [
    {
        title: 'Politica SST-FT-02',
        contents: 'Politicas de seguridad y salud en el trabajo',
        link: baseURL + 'SST-FT-02 Politica SG-SST.docx'
    },
    {
        title: 'Politica SST-FT-03',
        contents: 'Politica de no alcohol y sustancias psicoactivas',
        link: baseURL + 'SST-FT-03 Politica de no alcohol y sustancias psicoactivas.docx'
    },
    {
        title: 'Politica SST-FT-04',
        contents: 'Politica de acoso laboral',
        link: baseURL + 'SST-FT-04 Politica de acoso laboral.docx'
    },
    {
        title: 'Politica SST-FT-05',
        contents: 'MANUAL ORGANIZACION ARCHIVOS DE GESTION CURADURIA',
        link: baseURL + 'MANUAL ORGANIZACION ARCHIVOS DE GESTION CURADURIA.docx'
    },
]

